import { render } from "./organisation-persons.vue?vue&type=template&id=97373a60&scoped=true"
import script from "./organisation-persons.vue?vue&type=script&lang=js"
export * from "./organisation-persons.vue?vue&type=script&lang=js"

import "./organisation-persons.vue?vue&type=style&index=0&id=97373a60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97373a60"]])

export default __exports__